// import type User from '@@/types/user'

interface State {
  token: any // string | null
  user: any // User | null
}

export const useAuthStore = defineStore('auth', {
  state: () => {
    return {
      token: null,
      user: null
    } as State
  },
  persist: {
    pick: ['token']
  },
});
